






















































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import { UserModule } from '@/store/modules/user.module'
import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'

@Component({
  components: {
    Modal
  }
})
export default class SuccessMessage extends Vue {
  userModuleInstance: UserModule = getModule(UserModule, this.$store);

  get statistics () {
    return this.$store.state.user.workStatistics
  }

  get showMoreTasks () {
    if (!this.statistics) {
      return false
    }
    if (this.statistics.residentsInCollection || this.statistics.statementsInReview) {
      return true
    }
    return false
  }

  async mounted () {
    await this.userModuleInstance.fetchWorkStatistics()
  }
}
